import { Card } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";
import { Area, AreaChart, Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartBar, Star, TrendingUp } from "lucide-react";

const salesData = [
  { month: "Jan", amount: 2400 },
  { month: "Feb", amount: 1398 },
  { month: "Mar", amount: 9800 },
  { month: "Apr", amount: 3908 },
  { month: "May", amount: 4800 },
  { month: "Jun", amount: 3800 },
];

const productPerformance = [
  { name: "Electronics", sales: 450 },
  { name: "Fashion", sales: 380 },
  { name: "Home", sales: 280 },
  { name: "Sports", sales: 220 },
  { name: "Books", sales: 190 },
];

const SalesCharts = () => {
  const isMobile = useIsMobile();

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <Card className="p-6 hover:shadow-lg transition-all duration-300 bg-gradient-to-br from-white to-gray-50">
        <div className="flex items-center justify-between mb-6">
          <div className="space-y-1">
            <h2 className="text-lg font-semibold flex items-center gap-2">
              <ChartBar className="h-5 w-5 text-[#9b87f5]" />
              Sales Overview
            </h2>
            <p className="text-sm text-muted-foreground">Monthly revenue statistics</p>
          </div>
          <div className="flex items-center gap-2 px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium">
            <TrendingUp className="h-4 w-4" />
            +12.5%
          </div>
        </div>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={salesData}>
              <XAxis 
                dataKey="month" 
                tick={{ fontSize: isMobile ? 10 : 12 }}
              />
              <YAxis 
                tick={{ fontSize: isMobile ? 10 : 12 }}
                width={isMobile ? 30 : 40}
              />
              <Tooltip />
              <Area
                type="monotone"
                dataKey="amount"
                stroke="#9b87f5"
                fill="#E5DEFF"
                fillOpacity={0.8}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card className="p-6 hover:shadow-lg transition-all duration-300 bg-gradient-to-br from-white to-gray-50">
        <div className="flex items-center justify-between mb-6">
          <div className="space-y-1">
            <h2 className="text-lg font-semibold flex items-center gap-2">
              <Star className="h-5 w-5 text-[#F97316]" />
              Product Performance
            </h2>
            <p className="text-sm text-muted-foreground">Top selling categories</p>
          </div>
        </div>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={productPerformance}>
              <XAxis 
                dataKey="name" 
                tick={{ fontSize: isMobile ? 10 : 12 }}
              />
              <YAxis 
                tick={{ fontSize: isMobile ? 10 : 12 }}
                width={isMobile ? 30 : 40}
              />
              <Tooltip />
              <Bar dataKey="sales" fill="#9b87f5" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

export default SalesCharts;